export const getFolderSvg = (color = "black") => {
  const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
          <path fill="${color}" d="M11.17,6l3.42,3.41.58.59H28V26H4V6h7.17m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.59,4.59A2,2,0,0,0,11.17,4Z" />
        </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getPersonSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32">
      <title>user</title>
      <path fill="${color}" d="M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z"/>
      <path fill="${color}" d="M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"/>
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getCompanySvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <title>enterprise</title>
      <rect fill="${color}" x="8" y="8" width="2" height="4"/>
      <rect fill="${color}" x="8" y="14" width="2" height="4"/>
      <rect fill="${color}" x="14" y="8" width="2" height="4"/>
      <rect fill="${color}" x="14" y="14" width="2" height="4"/>
      <rect fill="${color}" x="8" y="20" width="2" height="4"/>
      <rect fill="${color}" x="14" y="20" width="2" height="4"/>
      <path fill="${color}" d="M30,14a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V30H30ZM4,4H20V28H4ZM22,28V14h6V28Z"/>
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getEmailSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22">
      <title>email</title>
      <path fill="${color}" d="M28,6H4A2,2,0,0,0,2,8V24a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V8A2,2,0,0,0,28,6ZM25.8,8,16,14.78,6.2,8ZM4,24V8.91l11.43,7.91a1,1,0,0,0,1.14,0L28,8.91V24Z" transform="translate(0)"/>
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" fill="none" width="32" height="32"/>
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getMobileSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32">
      <title>mobile</title>
      <path fill="${color}" d="M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"/>
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" fill="none" width="32" height="32"/>
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getFullNameSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="22" height="22">
      <defs>
          <style>.cls-1{fill:none;}</style>
      </defs>
      <title>identification</title>
      <path fill="${color}" d="M28,6V26H4V6H28m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z" />
      <rect fill="${color}" x="6" y="10" width="7" height="2" />
      <rect fill="${color}" x="6" y="14" width="4" height="2" />
      <path fill="${color}" d="M23,18H17a3,3,0,0,0-3,3v2h2V21a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v2h2V21A3,3,0,0,0,23,18Z" />
      <path fill="${color}" d="M20,17a4,4,0,1,0-4-4A4,4,0,0,0,20,17Zm0-6a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z" />
      <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1"
          width="22" height="22" />
    </svg>
  `;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getAddressSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 32 32">
      <defs>
        <style>
          .cls-1 {
          fill: none;
          }
        </style>
      </defs>
    <circle cx="24" cy="21" r="2" fill="${color}" />
    <path fill="${color}"
      d="M24,31l-4.7788-6.4019A5.9354,5.9354,0,0,1,18,21a6,6,0,0,1,12,0,5.9407,5.9407,0,0,1-1.2246,3.6028Zm0-14a4.0045,4.0045,0,0,0-4,4,3.9572,3.9572,0,0,0,.82,2.3972L24,27.6567l3.1763-4.2548A3.9627,3.9627,0,0,0,28,21,4.0045,4.0045,0,0,0,24,17Z" />
    <path fill="${color}"
      d="M25,5H22V4a2.0058,2.0058,0,0,0-2-2H12a2.0058,2.0058,0,0,0-2,2V5H7A2.0058,2.0058,0,0,0,5,7V28a2.0058,2.0058,0,0,0,2,2h9V28H7V7h3v3H22V7h3v5h2V7A2.0058,2.0058,0,0,0,25,5ZM20,8H12V4h8Z" />
    <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1"
      width="22" height="22" />
  </svg>
  `;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const getHashtagSvg = (color = "black") => {
  const svg = `
    <svg id="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 32 32">
      <defs>
        <style>
          .cls-1 {
          fill: none;
          }
        </style>
      </defs>
      <title>hashtag</title>
      <path fill="${color}" d="M28,12V10H22V4H20v6H12V4H10v6H4v2h6v8H4v2h6v6h2V22h8v6h2V22h6V20H22V12Zm-8,8H12V12h8Z" />
      <rect fill="none" id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1"
        width="18" height="18" />
    </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

export const ICONS = {
  FOLDER: getFolderSvg,
  PERSON: getPersonSvg,
  COMPANY: getCompanySvg,
  EMAIL: getEmailSvg,
  MOBILE: getMobileSvg,
  ADDRESS: getAddressSvg,
  HASHTAG: getHashtagSvg,
  FULLNAME: getFullNameSvg,
};

export const mapIcons = (icon?: string) => {
  console.assert(!!icon, "Icon is required");
  if (!icon) return () => undefined;
  return ICONS[icon] ?? (() => undefined);
};
